import React from 'react';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';
import ProcessManager from '../../../Common/Managers/ProcessManager';

const NuevaEntidad = (props) => {
    const objNuevaEntidadInstancia = {
        rutearNuevaInstancia: true,
        rutaNuevaInstancia: ProcessManager.GetNextStep("NuevaInstanciaParametro", "ROUTE_TO_NUEVA_INSTANCIA_PARAMETRO")
    }

    let genero = props.entidad.Genero ? "Nuevo" : "Nueva"

    return (
        <div className="row">
            <div className="col-md-12">
                <GenericSimpleButton text={genero} buttonClass="btn-orange" onClick={() => {
                    props.crearNuevaEntidadInstancia(objNuevaEntidadInstancia);
                }} />
            </div>
        </div>
    );
}

export default NuevaEntidad